import { createTheme } from "@mui/material";
import { ptBR } from "@mui/material/locale";

export const theme = createTheme({
  palette: {
    primary: {
      main: '#411e5a',
      contrastText: '#fff',
      light: '#6e4b87',
      dark: '#280a3c'
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "rgb(65, 30, 90)",
          "&:hover": {
            color: "rgb(189, 189, 189)",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          margin: 0,
        },
      },
    },
  },
}, ptBR);
